import { CircularProgress, Typography } from '@mui/material'

import React from 'react'

const Loading = ({message}) => {
    return (
        <div style={{ position: "absolute",minHeight:"100vh", height: "100%", width: "100%", display: "flex",flexDirection:"column", justifyContent: "center", alignItems: "center", zIndex: 100,top:0,left:0 }}>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#e01cd5" />
                        <stop offset="100%" stopColor="#1CB5E0" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
           {
            message&& <Typography sx={{ marginTop: 2 }}>{message}</Typography>
           }

        </div>
    )
}

export default Loading
